import { ClientsService } from '@services/client/clients.service';
import { contactsComponent } from '@pages/admin/contactos/contactos.component';
import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ObservatoryService, StorageService, NotificationsService, DsconfigService } from '@services/services.module';
import { FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ContactsService } from '@pages/admin/contactos/contactos.service';
import { registerClient } from '../../clients.model';
import { SearchInputDynamicComponent } from '@components/search-input-dynamic/search-input-dynamic.component';
import { APP_URLS } from '@app/constants/app-urls';

@Component({
  selector: 'app-form-clients',
  templateUrl: './form-clients.component.html',
  styleUrls: ['./form-clients.component.scss']
})
export class FormClientsComponent implements OnInit, OnDestroy {

  @ViewChild('contacts') contactsComponent: contactsComponent;
  @ViewChild('searchInput') searchInput: SearchInputDynamicComponent;
  @Input() textButton = '';

  private subscriptions: Array<Subscription> = [];
  private divisionModel: any;
  private clients = [];
  private clientAdded = '';
  public modelForm: any;
  public userData: any;
  public clearListClient: Subject<void> = new Subject<void>();
  public initDateClient: any;
  public endDateClient: any;
  public noModify = false;
  public noModifyAll = false;
  public contacts = [];
  public viaClient;
  public provincia;
  public oficinas = [];
  public wayToPay = [];
  public listAllClients: any = [];
  public APP_URLS = APP_URLS;
  public showValidatorError = false;
  public showSpecialCharacterValidator: boolean;
  public socialReasonValidator: boolean;
  public clientNameValidator: boolean;
  public sapClientValidator: boolean;
  public idManpowerValidator: boolean;
  public addressValidator: boolean;
  public restAddressValidator: boolean;
  public cityClientValidator: boolean;
  public numberStreetValidator: boolean;
  public availableButton = true;

  public postalCodeFormControl = new FormControl('', [
    // Validators.minLength(5)
  ]);

  constructor(
    private dsConfig: DsconfigService,
    private storage: StorageService,
    private observatory: ObservatoryService,
    private router: Router,
    public translate: TranslateService,
    private httpService: HttpClient,
    private clientsService: ClientsService,
    public contactsService: ContactsService,
    private notification: NotificationsService,
    private formBuilder: FormBuilder,
  ) {
    this.initModel();
    this.getAllData();
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.viaClient = this.dsConfig.getVia();
      this.provincia = this.dsConfig.getProvince();
    });
  }

  ngOnInit() {
    this.viaClient = this.dsConfig.getVia();
    this.provincia = this.dsConfig.getProvince();
  }

  initModel(): void {
    this.modelForm = this.formBuilder.group({
      adressClient: [''],
      numberStreetClient: [''],
      restAddressClient: [''],
      cifClient: ['', [Validators.required]],
      cityClient: [''],
      clientId: null,
      commercialBrand: [''],
      endDateClient: [''],
      initDateClient: [''],
      manpowerClient: ['', [Validators.required]],
      monthlyEstimateClient: null,
      nameClient: ['', [Validators.required]],
      officeId: ['', [Validators.required]],
      postalCodeClient: [''],
      provinceClient: [''],
      sapClient: ['', [Validators.required]],
      socialReasonClient: ['', [Validators.required]],
      viaClient: [''],
      wayToPayClient: [null, [Validators.required]],
      yearEstimateClient: null,
      startDate: [null, [Validators.required]],
      endDate: null
    });
  }

  // validateDniCif($event) {
  //   this.showValidatorError = $event;
  // }

  validateSpecialCharacters($event) {
    this.showSpecialCharacterValidator = $event;
    this.availableButton = $event;
  }

  validateSocialReason($event) {
    this.socialReasonValidator = $event;
    this.availableButton = $event;
  }

  validateClientName($event) {
    this.clientNameValidator = $event;
    this.availableButton = $event;
  }

  validateSapClient($event) {
    this.sapClientValidator = $event;
    this.availableButton = $event;
  }

  validateIdManpower($event) {
    this.idManpowerValidator = $event;
    this.availableButton = $event;
  }

  validateAddress($event) {
    this.addressValidator = $event;
    this.availableButton = $event;
  }

  validateRestAddress($event) {
    this.restAddressValidator = $event;
    this.availableButton = $event;
  }

  validateCityClient($event) {
    this.cityClientValidator = $event;
    this.availableButton = $event;
  }

  validateNumberStreet($event) {
    this.numberStreetValidator = $event;
    this.availableButton = $event;
  }

  getAllData() {
    this.subscriptions.push(
      this.clientsService.getOffices().subscribe((data: any[]) => {
        if (data && !this.oficinas.length) {
          this.oficinas = data;
        }
      }),
      this.clientsService.getWayToPay().subscribe((data: any[]) => {
        if (data && !this.wayToPay.length) {
          this.wayToPay = data;
        }
      })
    );
  }

  save(form: NgForm) {
    if (this.compareDates(this.modelForm.value.startDate, this.modelForm.value.endDate)) {
      const fechas = [
        { dateOne: this.modelForm.value.startDate },
        { dateTwo: this.modelForm.value.endDate },
      ];
      this.FormatParametersDate(fechas).then(
        (val: any) => {
          this.modelForm.value.endDateClient = val.dateTwo;
          this.modelForm.value.initDateClient = val.dateOne;

          window.scrollTo(0, 0);
          this.subscriptions.push(
            this.clientsService.addClient(this.modelForm.value).subscribe(data => {
              if (data.clientId) {
                this.notification.setSuccess(this.translate.instant('FORM_CLIENTES.REGISTRO_OK'));
                this.addContact(data.clientId);
                this.getClientInfo(data.clientId);

                const value = this.modelForm.value.nameClient;
                this.searchInput.value = value;
              }

              if (data.response === 'OK') {
                this.notification.setSuccess(this.translate.instant('FORM_CLIENTES.MODIFICACION_OK'));
                this.addContact(this.modelForm.value.clientId);
                this.getClientInfo(this.modelForm.value.clientId);
              }

              if (data.response !== 'OK' && !data.clientId) {
                this.notification.setWarning(this.translate.instant('ERRORS.' + data.response));
              }

              // refrescamos
              this.contactsComponent.refreshForm();
            })
          );
        }, (err) => {

        });
    }
  }

  getClientInfo(id) {
    this.subscriptions.push(
      this.clientsService.getAllClients().subscribe(listCliData => {
        if (listCliData) {
          this.listAllClients = listCliData;
          this.storage.remove('listAllClients');
          this.listAllClients.sort(function (a, b) {
            if (a.nameClient < b.nameClient) { return -1; }
            if (a.nameClient > b.nameClient) { return 1; }
            return 0;
          });
          this.listAllClients.map(function (item) {
            item.campoCompleto = item.nameClient;
            item.Id = item.ClientId;
            return item;
          });
          this.storage.set('listAllClients', this.listAllClients);

          // recaragmos la ista de clientes del searchInput
          this.searchInput.getList();

          this.observatory.setData('updateList', null);
          this.clientAdded = this.listAllClients.find(m => m.clientId === id);

          // forzar eliminar el ultimo elemento buscado en el buscador
          this.observatory.setData('idItemList', this.clientAdded);
          this.getClient(this.clientAdded);
        }
      })
    );
  }

  addContact(id) {
    const contactsLength = this.contactsComponent.newContact.get('contact')['controls'].length;
    const contacts = this.contactsComponent.newContact.get('contact')['controls'];
    let contactSended = [];

    for (let c = 0; c < contactsLength; c++) {
      if (contacts[c].get('nameContact').value &&
        contacts[c].get('contactPhone1').value &&
        contacts[c].get('emailContact').value ) {

          if (contacts[c].get('emailContact').value.match('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')) {
            contactSended = [{
              'clientId': id,
              'nameContact': contacts[c].get('nameContact').value,
              'surnamesContact': contacts[c].get('surnamesContact').value,
              'contactPosition': contacts[c].get('contactPosition').value,
              'contactPhone1': contacts[c].get('contactPhone1').value,
              'contactPhone2': contacts[c].get('contactPhone2').value,
              'emailContact': contacts[c].get('emailContact').value
            }];
            this.contactsService.updateContact(contactSended[0]).subscribe();
          }
      }
    }
  }

  FormatParametersDate(fechas) {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      let endMonth = '';
      let endDay = '';
      let initMonth = '';
      let initDay = '';
      let dateEnd;
      let dateInit;

      if (!!fechas.length) {
        fechas.forEach(element => {
          endMonth = '';
          endDay = '';
          initMonth = '';
          initDay = '';

          if (element.dateOne) {
            if (element.dateOne !== null && element.dateOne !== undefined) {
              if (element.dateOne.getDate() < 10) {
                initDay = '0' + element.dateOne.getDate();
              } else {
                initDay = '' + element.dateOne.getDate();
              }
              if (Number(element.dateOne.getMonth() + 1) < 10) {
                initMonth = '0' + Number(element.dateOne.getMonth() + 1);
              } else {
                initMonth = '' + Number(element.dateOne.getMonth() + 1);
              }
              dateInit = '' + element.dateOne.getFullYear() + initMonth + initDay;
            } else {
              dateInit = '';
            }
          } else if (element.dateTwo) {
            if (element.dateTwo !== null && element.dateTwo !== undefined) {
              if (element.dateTwo.getDate() < 10) {
                endDay = '0' + element.dateTwo.getDate();
              } else {
                endDay = '' + element.dateTwo.getDate();
              }
              if (Number(element.dateTwo.getMonth() + 1) < 10) {
                endMonth = '0' + Number(element.dateTwo.getMonth() + 1);
              } else {
                endMonth = '' + Number(element.dateTwo.getMonth() + 1);
              }
              dateEnd = '' + element.dateTwo.getFullYear() + endMonth + endDay;
            } else {
              dateEnd = '';
            }
          }
        });
        const returned = {
          'dateTwo': dateEnd,
          'dateOne': dateInit
        };
        resolve(returned);
      }
    });
  }

  compareDates(entryDate, expiryDate): boolean {
    if (expiryDate === null || expiryDate === undefined || expiryDate === '') {
      return true;
    }
    if (entryDate === null || entryDate === undefined || entryDate === '') {
      return true;
    }
    if (entryDate <= expiryDate) {
      return true;
    } else {
      this.notification.setWarning(this.translate.instant('FORM_CLIENTES.ENDDATE_OVER_STARTDATE'));
      return false;
    }
  }

  getContactsClient(clientId) {
    this.subscriptions.push(
      this.contactsService.getContactData(clientId).subscribe(data => {
        if (data) {
          this.contacts = data;
          this.contactsComponent.contacts = this.contacts;
        }
      })
    );
  }

  getClient(cliente) {
    this.textButton = this.translate.instant('MODCL');
    this.observatory.setData('textHeader', 'modify');

    // COMPROBAR SI LLEGA FECHA DE alta --> dar formato fecha al campo
    if (cliente.initDateClient) {
      const year = cliente.initDateClient.replace(/-/g, '').substring(0, 4);
      const month = cliente.initDateClient.replace(/-/g, '').substring(4, 6);
      const day = cliente.initDateClient.replace(/-/g, '').substring(6, 8);
      cliente.startDate = new Date(Number(year), Number(month) - 1, Number(day));
    }
    //  COMPROBAR SI LLEGA FECHA DE BAJA --> bloquear formulario y dar formato fecha al campo
    if (cliente.endDateClient) {
      const year = cliente.endDateClient.replace(/-/g, '').substring(0, 4);
      const month = cliente.endDateClient.replace(/-/g, '').substring(4, 6);
      const day = cliente.endDateClient.replace(/-/g, '').substring(6, 8);
      cliente.endDate = new Date(Number(year), Number(month) - 1, Number(day));
    }
    if (!cliente.sapClient) {
      this.textButton = this.translate.instant('NCLI');
      this.noModify = false;
    } else {
      this.noModify = true;
    }
    if (cliente.endDateClient) {
      this.noModifyAll = true;
    } else {
      this.noModifyAll = false;
    }
    this.modelForm.setValue({
      adressClient: cliente.adressClient ? cliente.adressClient : '',
      numberStreetClient: cliente.numberStreetClient ? cliente.numberStreetClient : '',
      restAddressClient: cliente.restAddressClient ? cliente.restAddressClient : '',
      cifClient: cliente.cifClient ? cliente.cifClient : '',
      cityClient: cliente.cityClient ? cliente.cityClient : '',
      clientId: cliente.clientId ? cliente.clientId : '',
      commercialBrand: cliente.commercialBrand ? cliente.commercialBrand : '',
      endDateClient: cliente.endDateClient ? cliente.endDateClient : '',
      initDateClient: cliente.initDateClient ? cliente.initDateClient : '',
      manpowerClient: cliente.manpowerClient ? cliente.manpowerClient : '',
      monthlyEstimateClient: cliente.monthlyEstimateClient ? cliente.monthlyEstimateClient : '',
      nameClient: cliente.nameClient ? cliente.nameClient : '',
      officeId: cliente.officeId ? cliente.officeId : '',
      postalCodeClient: cliente.postalCodeClient ? cliente.postalCodeClient : '',
      provinceClient: cliente.provinceClient ? cliente.provinceClient : '',
      sapClient: cliente.sapClient ? cliente.sapClient : '',
      socialReasonClient: cliente.socialReasonClient ? cliente.socialReasonClient : '',
      viaClient: cliente.viaClient ? cliente.viaClient : '',
      wayToPayClient: cliente.wayToPayClient ? cliente.wayToPayClient : '',
      yearEstimateClient: cliente.yearEstimateClient ? cliente.yearEstimateClient : '',
      startDate: cliente.startDate ? cliente.startDate : '',
      endDate: cliente.endDate ? cliente.endDate : '',
    });
    this.getContactsClient(this.modelForm.value.clientId);
  }

  resetFormulario(form: NgForm) {
    if (form) {
      form.reset();
    }
    // tslint:disable-next-line:forin
    for (const campo in this.modelForm) {
      this.modelForm.controls[campo].setValue(null);
    }
    this.divisionModel = null;
    this.modelForm.controls.initDateClient.setValue(null);
    this.modelForm.controls.startDate.setValue(null);
    this.modelForm.controls.clientId.setValue(null);
  }

  convertDateToStringFormat(value, type) {
    const date = [
      { dateOne: value }
    ];
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

  deleteContact(contact) {
    if (contact.contactId) {
      this.contactsService.deleteContact(contact).subscribe(val => {

        this.getContactsClient(this.modelForm.value.clientId);
      }, error => {
      });
    }
  }

  cancel(form: NgForm) {
    this.searchInput.value = '';
    this.searchInput.enableInput = false;
    this.initModel();
    this.textButton = this.translate.instant('CRCLI');
    this.observatory.setData('textHeader', 'new');
    this.clearListClient.next();
    // reset boolena disabled
    this.noModify = false;
    this.noModifyAll = false;
    // reset contacts
    this.contacts = [];
    this.contactsComponent.refreshForm();
  }

  buttonSuccessValidation() {
    return  this.modelForm.value.startDate && !this.noModifyAll
      // || this.postalCodeFormControl.hasError('minlength')
      && !this.showValidatorError && this.availableButton;
  }

  setStartDate($event): void {
    this.modelForm.controls.startDate.setValue($event);
  }
  setEndDate($event): void {
    this.modelForm.controls.endDate.setValue($event);
    this.modelForm.controls.endDateClient.setValue($event);
  }

}
